/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MatMenuItemBase as ɵa,_MatMenuItemMixinBase as ɵb} from './menu-item';
export {MAT_MENU_SCROLL_STRATEGY_PROVIDER as ɵd,MAT_MENU_SCROLL_STRATEGY_PROVIDER_FACTORY as ɵc} from './menu-trigger';